define.alias("shared/components/shared/ui/search-box/result", "settings/components/shared/ui/search-box/result");